import { useEffect, useState } from "react";

import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCircleImg from "UI/FnrCircleImg/FnrCircleImg";
import FnrDeleteButton from "UI/FnrDeleteButton/FnrDeleteButton";
import FnrErrorText from "UI/FnrErrorText/FnrErrorText";
import FnrFade from "UI/FnrFade/FnrFade";
import FnrLoadingBricks from "UI/FnrLoadingBricks/FnrLoadingBricks";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import { useGroupsWithNetworkField } from "./apiHook";

const OtherGroup = ({ name, photoURL, groupId, update, isLast }) => {
  const [title] = extendedFieldHooks.useTitle();
  const [isLoading, deleteExtendedField] =
    extendedFieldHooks.useDeleteExtendedField(groupId);
  const [isDeleted, setIsDeleted] = useState(false);
  const [, initExtendedFields] = extendedFieldHooks.useInitExtendedFields();

  const handleDelete = () => {
    deleteExtendedField().then(() => {
      setIsDeleted(true);
      update(); // Update the source of truth.
      initExtendedFields(); // See if we need to display this component at all anymore.
    });
  };

  return (
    <FnrFade show={!isDeleted}>
      <FnrHorizontalGap>
        <FnrCircleImg url={photoURL} />
        <FnrTypography fontSize="lg">{name}</FnrTypography>
        <FnrDeleteButton
          variant="iconButton"
          confirmText={
            isLast ? (
              <>
                <FnrTypography color="textLight">
                  Are you sure you want to remove the {title} field from your
                  members&apos; profiles?
                </FnrTypography>{" "}
                <FnrTypography bold color="textLight">
                  You could lose any responses members have made on this field.
                </FnrTypography>
              </>
            ) : (
              <FnrTypography color="textLight">
                Are you sure you want to remove the {title} field from from this
                group?
              </FnrTypography>
            )
          }
          onClick={handleDelete}
        />
        <FnrLoadingBricks show={isLoading} />
      </FnrHorizontalGap>
    </FnrFade>
  );
};

const ActiveInOtherGroups = () => {
  const [{ data, hasError, isLoading }, update] = useGroupsWithNetworkField();

  useEffect(update, [update]);

  return (
    <FnrVerticalGap data-cy="ExtendedFields_ActiveInOtherGroups">
      <FnrTypography>
        This extended profile field is active in the following groups:
      </FnrTypography>
      <FnrFade show={Boolean(data.length) && !isLoading}>
        <FnrVerticalGap gap={8}>
          {data.map(({ ID: groupId, ...props }) => (
            <OtherGroup
              key={groupId}
              groupId={groupId}
              update={update}
              isLast={data.length === 1}
              {...props}
            />
          ))}
        </FnrVerticalGap>
      </FnrFade>
      <FnrLoadingBricks show={isLoading} />
      <FnrErrorText error={hasError}>
        Getting those groups for you did not go well.
      </FnrErrorText>
    </FnrVerticalGap>
  );
};

export default ActiveInOtherGroups;
